import { FC, ReactNode } from "react";
import styles from "./ExpandableSection.module.scss";

interface Props {
    isOpen: boolean;
    children: ReactNode;
}

export const ExpandableSection: FC<Props> = ({ isOpen, children }) => (
    <div
        className={styles.slot}
        data-open={isOpen ? "" : undefined}
        inert={!isOpen}
    >
        <div className={styles.clip}>{children}</div>
    </div>
);
